<template>
  <div class="form-group mb-3 privacy-consent semi-privacy-check">
    <div class="custom-control custom-checkbox">
      <input type="hidden" name="privacy" :value="value ? 'true' : 'false'" />
      <input
        :id="id"
        :checked="value"
        class="custom-control-input"
        type="checkbox"
        @change="$emit('input', $event.target.checked)"
      />
      <label class="custom-control-label" style="font-size: 12px !important" :for="id">
        Acepto los
        <a :href="privacyUrl" target="_blank" rel="noopener">términos y condiciones</a> de la
        política de privacidad
      </label>
    </div>
    <div v-if="invalid" class="error-data">Debes aceptar las políticas de privacidad</div>
  </div>
</template>

<script>
  export default {
    name: 'PrivacyConsent',
    props: {
      id: {
        type: String,
        required: true,
      },
      value: {
        type: Boolean,
        default: false,
      },
      invalid: {
        type: Boolean,
        default: false,
      },
      privacyUrl: {
        type: String,
        default: '/bases-legales',
      },
    },
  };
</script>

<style scoped>
  .privacy-consent a {
    color: #003147 !important;
    text-decoration: underline;
  }

  .privacy-consent .custom-control-label {
    color: #707070 !important;
  }

  .privacy-consent .error-data {
    font-size: 0.7rem;
  }
</style>
